import './BlogPostWrapper.css';
import DOMPurify from 'dompurify';
import { useContext, useEffect, useRef, useState } from "react";
import { ErrorComp } from '../common/Common';
import { BlogPost } from '../common/BlogPost';
import { LocaleContext, ScrollContext } from '../common/App';
import { useAutoLoad, useModAEles, useNavigateSmart } from '../common/hooks';
import { LoadState } from '../common/enums.mjs';
import { modifyAElesCustomer } from '../common/util';
import { ConsumerContext } from '..';


export const BlogPostWrapper = ({id}) => {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();

    const [postData, setPostData] = useState(null);

    const curId = useRef(id);


    // EFFECTS:

    useEffect(() => {
        curId.current = id;
        resetLoading();
    }, [id]);

    const [loadState, setLoadState, resetLoading] = useAutoLoad((json) => {
        // On load success

        json.introduction_text_html = modifyAElesCustomer(DOMPurify.sanitize(json.introduction_text_html));
        json.main_text_html = modifyAElesCustomer(DOMPurify.sanitize(json.main_text_html));

        setPostData(json);
    }, () => {
        // On load error
    }, () => {

        return "/user/get_blog_post?id=" + (curId.current ? curId.current : -1);
    }, [id], true, false, false, false, true);

    useModAEles(consumer);


    // RENDER:

    return (
        <div className="blog_post_wrapper">
            { loadState === LoadState.LOAD_ERROR ?
                <div className="blog_post_wrapper_content side_padding bottom_padding">
                    <ErrorComp text={locale.msgs.GENERAL_ERROR_DESCR}/>
                </div>
            : loadState === LoadState.LOAD_SUCCESS ?
                <div className="blog_post_wrapper_content side_padding bottom_padding">
                    <BlogPost postData={postData}
                            showNextPostBtn={postData.next_id}
                            showPrevPostBtn={postData.prev_id}
                            onBackClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/blog/");
                            }}
                            onNextPostClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/blog/post/?id=" + postData.next_id);
                            }}
                            onPrevPostClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/blog/post/?id=" + postData.prev_id);
                            }}
                    />
                </div>
            :
                null
            }

        </div>
    );
}
